__turbopack_context__.v({
  "confirm": "index-module-scss-module__GvXPJa__confirm",
  "popupBody": "index-module-scss-module__GvXPJa__popupBody",
  "popupHeader": "index-module-scss-module__GvXPJa__popupHeader",
});
